// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"GM-z","carouselContainer":"HM-z"};